export enum AuditOperationCategories {
  DetailsChange = "DetailsChange",
  StatusChange = "StatusChange",
  LicenceChange = "LicenceChange",
  OrganisationChange = "OrganisationChange",
}
